import { createSelector } from 'reselect';
import api from './api';
import { combineReducers } from '../../node_modules/redux';

const stateVenueSelector = (state) => state.venue;

export const selector = createSelector([stateVenueSelector], (venue) => {
  return { ...venue };
});

const VENUE_FETCH_ALL_REQUEST = 'VENUE_FETCH_ALL_REQUEST';
const VENUE_FETCH_ALL_SUCCESS = 'VENUE_FETCH_ALL_SUCCESS';
const VENUE_FETCH_ALL_FAILURE = 'VENUE_FETCH_ALL_FAILURE';

const VENUE__CREATE_REQUEST = 'VENUE__CREATE_REQUEST';
const VENUE__CREATE_SUCCESS = 'VENUE__CREATE_SUCCESS';
const VENUE__CREATE_FAILURE = 'VENUE__CREATE_FAILURE';

const VENUE__UPDATE_REQUEST = 'VENUE__UPDATE_REQUEST';
const VENUE__UPDATE_SUCCESS = 'VENUE__UPDATE_SUCCESS';
const VENUE__UPDATE_FAILURE = 'VENUE__UPDATE_FAILURE';

const VENUE__RESET_NEW_VENUE = 'VENUE__RESET_NEW_VENUE';
const VENUE__UPDATE_NEW_VENUE = 'VENUE__UPDATE_NEW_VENUE';
const VENUE__UPDATE_EDIT_VENUE = 'VENUE__UPDATE_EDIT_VENUE';

const VENUE__DELETE_REQUEST = 'VENUE__DELETE_REQUEST';
const VENUE__DELETE_SUCCESS = 'VENUE__DELETE_SUCCESS';
const VENUE__DELETE_FAILURE = 'VENUE__DELETE_FAILURE';

const initialState = {
    venue: {},
    newVenue: {
      firstName: '',
      lastName: '',
      title: '',
      email: ''
    }
};

export const actionCreators = {
  resetVenue: () => ({type: VENUE__RESET_NEW_VENUE }),
  updateNewVenue: (venue) => ({type: VENUE__UPDATE_NEW_VENUE, venue}),
  updateEditVenue: (venue) => ({type: VENUE__UPDATE_EDIT_VENUE, venue}),
  getVenue: () =>
    api({
      types: [VENUE_FETCH_ALL_REQUEST, VENUE_FETCH_ALL_SUCCESS, VENUE_FETCH_ALL_FAILURE],
      uri: '/api/venue',
      config: {
        method: 'GET',
        headers: {
          Accept: 'application/json',
          'Content-Type': 'application/json',
        },
      },
      sendJwtBearer: true,
    }),
  createVenue: (venue) =>
    api({
      types: [VENUE__CREATE_REQUEST, VENUE__CREATE_SUCCESS, VENUE__CREATE_FAILURE],
      uri: '/api/venue',
      config: {
        method: 'POST',
        headers: {
          Accept: 'application/json',
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(venue),
      },
      payload: venue,
      sendJwtBearer: true,
    }),
  deleteVenue: (venue) =>
    api({
      types: [VENUE__DELETE_REQUEST, VENUE__DELETE_SUCCESS, VENUE__DELETE_FAILURE],
      uri: '/api/venue',
      config: {
        method: 'DELETE',
        headers: {
          Accept: 'application/json',
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(venue),
      },
      payload: venue,
      sendJwtBearer: true,
    }),
  updateVenue: (venue) => 
    api({
      types: [VENUE__UPDATE_REQUEST, VENUE__UPDATE_SUCCESS, VENUE__UPDATE_FAILURE],
      uri: '/api/venue',
      config: {
        method: 'PUT',
        headers: {
          Accept: 'application/json',
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(venue),
      },
      payload: venue,
      sendJwtBearer: true,
    }),
};

const venue = (state = initialState.venue, action) => {
  switch(action.type) {
    case VENUE__CREATE_SUCCESS:
      return {...state, [action.response]:{...action.payload, id: action.response} };
    case VENUE_FETCH_ALL_SUCCESS:
      return {...state, ...action.response.reduce((obj, item) => {
        obj[item.id] = item
        return obj
      }, {})}
    case VENUE__UPDATE_EDIT_VENUE:
      return {...state, ...{[action.venue.id]: action.venue}}
    case VENUE__DELETE_SUCCESS: {
        const newState = {...state};
        delete newState[action.payload.id]
        return {...newState}
      }
    default: 
      return {...state};
  }
};

const newVenue = (state = initialState.newVenue, action) => {
  switch(action.type) {
    case VENUE__UPDATE_NEW_VENUE:
    return {...state, ...action.venue};
    case VENUE__RESET_NEW_VENUE:
    return {...initialState.newVenue};
    default:
    return {...state};
  }
};

export const reducer = combineReducers({
  venue,
  newVenue
});